const NoPage = () => {
  return <div>404 not found</div>;
};

export default NoPage;
